import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { makeStyles } from "@material-ui/core/styles";
import ViewPoliticaDePrivacidadeESeguranca from 'components/View/ViewPoliticaDePrivacidadeESeguranca';
import ViewPoliticaDePagamentos from 'components/View/ViewPoliticaDePagamentos';
import ViewTermosECondicoes from 'components/View/ViewTermosECondicoes';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const styles = {
    appBar: {
        position: 'relative',
        backgroundColor: '#00ACC1',
    }
};
const useStyles = makeStyles(styles);

export default function Termos(props) {
    const [openPrivacidadeESeguranca, setOpenPrivacidadeESeguranca] = useState(false);
    const [openPoliticaDePagamentos, setOpenPoliticaDePagamentos] = useState(false);
    const [openTermosECondicoes, setOpenTermosECondicoes] = useState(false);
    const classes = useStyles();

    const handleOpenPrivacidadeESeguranca = () => {
        //setOpenPrivacidadeESeguranca(true);
        window.open('https://condutorlegal.com.br/TERMOS_DE_USO_CONDICOES_DE_USO_POLITICAS_DE_PRIVACIDADE_E_SEGURANCA_V3_01042025.pdf', '_blank');
    };

    const handleClosePrivacidadeESeguranca = () => {
        setOpenPrivacidadeESeguranca(false);
    };

    const handleOpenPoliticaDePagamentos = () => {
        window.open('https://condutorlegal.com.br/POLITICA_DE_PAGAMENTOS_E_CANCELAMENTOS_V3_01042025.pdf', '_blank');
    };

    const handleClosePoliticaDePagamentos = () => {
        setOpenPoliticaDePagamentos(false);
    };

    const handleOpenTermosECondicoes = () => {
        setOpenTermosECondicoes(true);
    };

    const handleCloseTermosECondicoes = () => {
        setOpenTermosECondicoes(false);
    };

    return (
        <>
            <Dialog 
                fullScreen 
                open={openPrivacidadeESeguranca} 
                TransitionComponent={Transition} 
                maxWidth={'sm'}
                aria-labelledby="max-width-dialog-title"
            >
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton color="inherit" onClick={handleClosePrivacidadeESeguranca} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <p style={{marginTop: '20px'}}>TERMOS DE USO, CONDIÇÕES DE USO, POLÍTICAS DE PRIVACIDADE E SEGURANÇA</p>
                    </Toolbar>
                </AppBar>
                <ViewPoliticaDePrivacidadeESeguranca />
            </Dialog>
            <Dialog 
                fullScreen 
                open={openPoliticaDePagamentos} 
                TransitionComponent={Transition} 
                maxWidth={'sm'}
                aria-labelledby="max-width-dialog-title"
            >
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton color="inherit" onClick={handleClosePoliticaDePagamentos} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <p style={{marginTop: '20px'}}>POLÍTICAS DE PAGAMENTO E CANCELAMENTOS</p>
                    </Toolbar>
                </AppBar>
                <ViewPoliticaDePagamentos />
            </Dialog>
            {/* <Dialog 
                fullScreen 
                open={openTermosECondicoes} 
                TransitionComponent={Transition} 
                maxWidth={'sm'}
                aria-labelledby="max-width-dialog-title"
            >
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton color="inherit" onClick={handleCloseTermosECondicoes} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <p style={{marginTop: '20px'}}>Termos e Condições</p>
                    </Toolbar>
                </AppBar>
                <ViewTermosECondicoes />
            </Dialog> */}
            <h2 style={{marginTop: '20px', textAlign: 'center'}}>Termos</h2>
            <ul>
                <li><a href="#" onClick={handleOpenPrivacidadeESeguranca}>TERMOS DE USO, CONDIÇÕES DE USO, POLÍTICAS DE PRIVACIDADE E SEGURANÇA</a></li>
                <li><a href="#" onClick={handleOpenPoliticaDePagamentos}>POLÍTICAS DE PAGAMENTO E CANCELAMENTOS</a></li>
                {/* <li><a href="#" onClick={handleOpenTermosECondicoes}>Termos e Condições</a></li> */}
            </ul>
        </>
    );
}